const LevelOneType = Object.freeze({
  SENTIMENT: 'SENTIMENT',
  SENTIMENT_WO_NEUTRAL: 'SENTIMENT_WO_NEUTRAL',
  GENDER: 'GENDER',
  GENDER_WO_UNKNOWN: 'GENDER_WO_UNKNOWN',
  NONE: 'NONE'
})
export default LevelOneType
export type LevelOneTypeStrings = typeof LevelOneType[keyof typeof LevelOneType]
// RESERVE BELOW
